<app-kontable #table
  id="dt_salesNetwork"
  [source]="divisions"
  title = "{{ 'division_sales_network.divisions_sales_network' | translate }}"
  [columns] = "[
  'id',
  'division_name',
  'sales_network_name',
  { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter }]"
  [titles] = "['common.id', 'division_sales_network.division_id', 'division_sales_network.sales_network_id']"
  [showInfoButton]="false"
  [showRecoverButton]="true"
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showAddButton]="true"
  [(fireNewDataAvailable)]="newDataAvailable"
  (onAdd)="showAddDialog()"
  (onEdit)="showEditDialog($event)"
  (onRemove)="delete($event)"
  (onRecover)="recoverDivision($event)" >

  <ng-template #stateTemplate data-testid="stateTemplate" let-row>
    <span *ngIf="row.flg_state && row.flg_state !== '0'" class="fa fa-trash-o" title="state"></span>
  </ng-template>

  <ng-template #stateFilter data-testid="stateFilter" let-col>
    <p-dropdown [options]="listStates" [style]="{'width':'100%'}" [(ngModel)]="table.filter.search[col.field]" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
  </ng-template>

</app-kontable>

<p-dialog *ngIf="showAddEditDialog"
          header="{{modalTitle}}"
          [width]="500"
          [(visible)]="showAddEditDialog"
          [responsive]="true"
          [modal]="true"
          (onHide)="onDialogHide()">
  <app-division-sales-network-form
    [divisionSalesNetworkId]="selectedDSNId"
    [dialogBoxSalesNetwork]="showAddEditDialog"
    (salesNetworkAdded)="salesNetworkAdded($event)"
    (salesNetworkUpdated)="salesNetworkUpdated($event)"
  ></app-division-sales-network-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/division-sales-network/division-sales-network.component.html